export enum OneOnOneLessonType {
  GeneralEnglish = "GeneralEnglish",
  BusinessEnglish = "BusinessEnglish",
}
